import { render, staticRenderFns } from "./EditName.vue?vue&type=template&id=a7d16eda&"
import script from "./EditName.vue?vue&type=script&lang=js&"
export * from "./EditName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports